import {
  TransactionModalInput,
  TransactionModalMode,
} from '../model/single-transaction/popup-input.model'

/**
 * Checks if modal input is for viewing a transaction in read-only mode.
 */
export function isViewOnlyModal(
  transInput: TransactionModalInput | undefined,
): boolean {
  return transInput?.readOnly === true
}

/**
 * Checks if modal input is for editing a transaction.
 */
export function isEditModal(
  transInput: TransactionModalInput | undefined,
): boolean {
  return (
    transInput !== undefined &&
    transInput.modalMode === TransactionModalMode.EditCWTran
  )
}

/**
 * Checks if modal input is for a Clearwater (aka internal) transaction.
 */
export function isClearwaterTransaction(
  transInput: TransactionModalInput | undefined,
): boolean {
  return (
    transInput !== undefined &&
    (transInput.modalMode === TransactionModalMode.CreateCWTran ||
      transInput.modalMode === TransactionModalMode.EditCWTran)
  )
}

/**
 * Checks if modal input is for a Clearwater Create
 */
export function isClearwaterCreateTransaction(
  transInput: TransactionModalInput | undefined,
): boolean {
  return (
    transInput !== undefined &&
    transInput.modalMode === TransactionModalMode.CreateCWTran
  )
}

/**
 * Checks if modal input is for an external transaction.
 */
export function isExternalTransaction(
  transInput: TransactionModalInput | undefined,
): boolean {
  return (
    transInput !== undefined &&
    transInput.modalMode === TransactionModalMode.CreateFromExtTran
  )
}

/**
 * Create a display string that represents transaction modal mode.
 */
export function displayModalMode(
  transInput: TransactionModalInput | undefined,
) {
  if (transInput === undefined) {
    return ''
  }

  if (transInput.readOnly) {
    return 'Clearwater transaction view'
  }

  switch (transInput.modalMode) {
    case TransactionModalMode.CreateFromExtTran:
      return 'External transaction create'
    case TransactionModalMode.CreateCWTran:
      return 'Clearwater transaction create'
    case TransactionModalMode.EditCWTran:
      return 'Clearwater transaction edit'
    case TransactionModalMode.CreateFromPosition:
      return 'Clearwater transaction create'
  }
}

/**
 * Given an existing modal mode, set that mode to be a "create" mode.
 */
export function modalModeToCreate(
  mode: TransactionModalMode,
): TransactionModalMode {
  switch (mode) {
    case TransactionModalMode.CreateFromExtTran:
      return TransactionModalMode.CreateFromExtTran
    case TransactionModalMode.CreateCWTran:
      return TransactionModalMode.CreateCWTran
    case TransactionModalMode.EditCWTran:
      return TransactionModalMode.CreateCWTran
    case TransactionModalMode.CreateFromPosition:
      return TransactionModalMode.CreateFromPosition
  }
}
